import { useRef } from "react";
import { Transition, type TransitionStatus } from "react-transition-group";
import { VoteEnded } from "./VoteEnded";
import { VoteResults } from "./VoteResults";
import { VoteVoting } from "./VoteVoting";
import { VoteWaiting } from "./VoteWaiting";
import { useVotingSession } from "~/providers/votingSession/VotingSessionContext";

export interface VoteRouteProps extends React.RefAttributes<HTMLDivElement> {
  transitionState: TransitionStatus;
}

export function VoteScreen() {
  const { session } = useVotingSession();

  return (
    <div className="grid h-full overflow-clip *:col-span-full *:row-span-full">
      <Route active={session.state === "waiting"} component={VoteWaiting} />
      <Route active={session.state === "voting"} component={VoteVoting} />
      <Route active={session.state === "results"} component={VoteResults} />
      <Route active={session.state === "ended"} component={VoteEnded} />
    </div>
  );
}

function Route({
  active,
  component: Component,
}: {
  active: boolean;
  component: React.ComponentType<VoteRouteProps>;
}) {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <Transition nodeRef={ref} in={active} timeout={500} appear={true} mountOnEnter>
      {(transitionState) => <Component transitionState={transitionState} ref={ref} />}
    </Transition>
  );
}
